import { render, staticRenderFns } from "./BalanceCell.vue?vue&type=template&id=c52ec7e0&"
import script from "./BalanceCell.vue?vue&type=script&lang=babel&"
export * from "./BalanceCell.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports